export enum TAX_TYPE {
  NON_TAXABLE = "NON_TAXABLE",
  OUT_OF_SCOPE = "OUT_OF_SCOPE",
  NON_GST_SUPPLY = "NON_GST_SUPPLY",
  GST0 = "GST0",
  GST0_1 = "GST0_1",
  GST0_25 = "GST0_25",
  GST1 = "GST1",
  GST1_5 = "GST1_5",
  GST3 = "GST3",
  GST5 = "GST5",
  GST6 = "GST6",
  GST7_5 = "GST7_5",
  GST12 = "GST12",
  GST18 = "GST18",
  GST28 = "GST28",
}

export const TAXES = [
  {
    name: "GST0 (0%)",
    value: TAX_TYPE.GST0,
    desc: "",
  },
  {
    name: "GST0.1 (0.1%)",
    value: TAX_TYPE.GST0_1,
    desc: "",
  },
  {
    name: "GST0.25 (0.25%)",
    value: TAX_TYPE.GST0_25,
    desc: "",
  },
  {
    name: "GST1 (1%)",
    value: TAX_TYPE.GST1,
    desc: "",
  },
  {
    name: "GST1.5 (1.5%)",
    value: TAX_TYPE.GST1_5,
    desc: "",
  },
  {
    name: "GST3 (3%)",
    value: TAX_TYPE.GST3,
    desc: "",
  },
  {
    name: "GST5 (5%)",
    value: TAX_TYPE.GST5,
    desc: "",
  },
  {
    name: "GST6 (6%)",
    value: TAX_TYPE.GST6,
    desc: "",
  },
  {
    name: "GST7.5 (7.5%)",
    value: TAX_TYPE.GST7_5,
    desc: "",
  },
  {
    name: "GST12 (12%)",
    value: TAX_TYPE.GST12,
    desc: "",
  },
  {
    name: "GST18 (18%)",
    value: TAX_TYPE.GST18,
    desc: "",
  },
  {
    name: "GST28 (28%)",
    value: TAX_TYPE.GST28,
    desc: "",
  },
  {
    name: "Non Taxable",
    value: TAX_TYPE.NON_TAXABLE,
    desc: "",
  },
  {
    name: "Out of scope",
    value: TAX_TYPE.OUT_OF_SCOPE,
    desc: "Supplies on which you don’t charge any GST or include them in the returns",
  },
  {
    name: "Non - GST Supply",
    value: TAX_TYPE.NON_GST_SUPPLY,
    desc: "Supplies which do not come under GST such as petroleum products and Liquor",
  },
];
